import React from "react";
import IOT from "../../assets/Image/iot10.jpg";

function IotChatbot() {
  return (
    <div className="container">
      <div className="row justify-content-center align-items-center mt-5 mb-5">
        <div className="col-lg-6 col-md-12 col-sm-12">
          <div data-aos="fade-up">
            <img src={IOT} className="img-fluid" alt="" />
          </div>
        </div>
        <div className="col-lg-6 col-md-12 col-sm-12">
          <h1 className="Text-heading" data-aos="fade-up">
            Iot DashBoards
          </h1>
          <p className="text-detail mt-5" data-aos="fade-up">
            With the help of Virtual Tech, configure IoT devices, and manage
            cyber-physical systems both remotely as well as with BI tools via
            several dashboards.
          </p>
          <ul className="text-detail" data-aos="fade-up">
            <li>Web-based HMIs</li>
            <li>Predictive Maintenance systems</li>
            <li>Real-time sensor data visualizations</li>
          </ul>
          <div className="mt-3" data-aos="fade-up">
            <button className="btn btn-experts p-3">Contact Us Now</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default IotChatbot;
